import { styled as StyledMui } from "@mui/system";
import { Box, Typography } from "@mui/material";

export const NoRecordsTypography = StyledMui(Typography)(({ theme }) => ({
  fontSize: "1.8rem",
  color: theme.bniRed.main,
  fontWeight: "700",
  textAlign: theme.direction === "ltr" ? "left" : "right",
  gridColumn: "1/-1",
  justifySelf: "center",
  animation: "fadeanimation 2s infinite",
  "@media only screen and (max-width: 1065px)": {
    width: "90vw",
    textAlign: "center",
  },
}));

export const BniLoaderBox = StyledMui(Box)(() => ({
  gridColumn: "1/-1",
}));
